<ion-header class="ion-no-border">
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/customers"></ion-back-button>
        </ion-buttons>
        <ion-title>Customer Details</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div sxPadding="medium" sxCol sxGap="20px" sxMaxWidth="800px" sxMargin="0 auto">
        <!-- Customer Profile Section -->
        <div sxBackground="light" sxRadius="medium" sxPadding="medium" sxRow sxAlign="center" sxGap="20px">
            <avatar-round [title]="customer?.targetAccount?.name || ''"
                [imageUrl]="customer?.targetAccount?.displayPictureUrl" [size]="80">
            </avatar-round>
            <div sxCol sxGap="5px">
                <h2>{{ customer?.targetAccount?.name }}</h2>
                <p>{{ customer?.targetAccount?.email }}</p>
            </div>
        </div>

        <!-- Customer Details Section -->
        <div sxBackground="light" sxRadius="medium" sxPadding="medium" sxCol sxGap="15px">
            <h3>Contact Information</h3>
            <div sxRow sxGap="20px">
                <div sxCol>
                    <p class="label">Phone</p>
                    <p>{{ customer?.targetAccount?.phoneNumber || '' }}</p>
                </div>
                <!-- <div sxCol>
                    <p class="label">Address</p>
                    <p>{{ customer?.targetAccount?.country || '' }}</p>
                </div> -->
            </div>
        </div>

        <!-- Additional sections can be added here -->
    </div>
</ion-content>